import { Door } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useUpdateDoorQuery = (doorId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/doors/${doorId}`
	return useLazyQuery<Door, void>(url, "PATCH")
}
